import { render } from "./Performance.vue?vue&type=template&id=9d85f484&scoped=true"
import script from "./Performance.vue?vue&type=script&lang=js"
export * from "./Performance.vue?vue&type=script&lang=js"

import "./Performance.vue?vue&type=style&index=0&id=9d85f484&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9d85f484"

export default script